<template>
    <div class="kpi">
        <h2 class="page-title">
        Practice Insights: KPIs
        </h2>
        <div>
          <ErrorDisplay/>
          <b-tabs
            active-nav-item-class="font-weight-bold"
            active-tab-class="font-weight-bold"
            content-class=""
          >
            <b-tab disabled>
              <template v-slot:title>
                Yesterday (coming soon)
                <span></span>
              </template>
            </b-tab>
            <b-tab v-if="allSettings" title="Today" active> <!-- content for Today's tab -->
                <b-row>
                  <b-col>
                  <Widget class="mb-3" kpiHelpProductionCollection showTooltip customHeader>  
                    <b-row>
                      <b-col class="px-xl-3" md="12" lg="6" sm="12" xs="12" xl="6"> <!-- start of Production (net) panel -->
                          <div>
                          <h5 class="fw-bold mt-3">Net Production(Completed): <span v-if="netAdjustedProductionTotal" class="h2 fw-semi-bold">{{this.netAdjustedProductionTotal | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span> </h5>
                            <div v-if="netAdjustedProductionTotalPercentageCompleted && allSettings && allSettings.PRACTICE_INSIGHTS_DAILY_NET_PRODUCTION_GOAL && (allSettings.PRACTICE_INSIGHTS_DAILY_NET_PRODUCTION_GOAL.PropertyValue !== '' || allSettings.PRACTICE_INSIGHTS_DAILY_NET_PRODUCTION_GOAL.PropertyValue !== null)">
                              <div class="clearfix fs-mini mt" >
                                <span class="pull-right m-0 fw-semi-bold">Daily Goal: <span class="fw-semi-bold">{{allSettings.PRACTICE_INSIGHTS_DAILY_NET_PRODUCTION_GOAL.PropertyValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></span>
                                <span class="fs-mini">{{netAdjustedProductionTotalPercentageCompleted}}% of Daily Goal Met</span>
                              </div>
                              <b-progress max="100" variant="success" class="bg-gray-lighter progress-xs mb-4" :value="netAdjustedProductionTotalPercentageCompleted"  />
                            </div>
                            <div v-if="productionDataByProvider && productionDataByProvider.length === 0"><span class="h3 fw-semi-bold text-secondary"><i class="fa fa-frown-o"></i> No appointments found on schedule!</span></div>
                            <div v-else class="table-responsive">
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th>Provider</th>
                                    <th class="hidden-sm-down">Net Production (completed)</th>
                                    <th class="hidden-sm-down">Scheduled (Net)</th>
                                    <!--<th class="hidden-sm-down">Completed %</th>-->
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(provider, index) in productionDataByProvider" :key="index">
                                    <td>
                                      {{provider.provider}}
                                      <p v-if="provider.IsSecondary === 1">
                                        <small>
                                          <span class="text-muted">Hygienist</span>
                                        </small>  
                                      </p>
                                    </td>
                                    <td>
                                      <p class="mb-0 h5 fw-semi-bold">{{provider.productionTotal | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</p>
                                      </td>
                                    <td>
                                      <p class="h5 fw-semi-bold">{{provider.scheduledTotal | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</p>
                                    </td>
                                    <!--
                                    <td class="width-150">
                                      <p>
                                        <small>
                                          <span class="fw-semi-bold">Goal:</span>
                                          <span class="text-muted">&nbsp; #CHANGE ME#</span>
                                        </small>  
                                      </p>
                                      <b-progress max="100" variant="warning" class="bg-gray-lighter progress-sm mb-xs" value="50"  />
                                    </td>
                                    -->
                                  </tr>
                                  
                                </tbody>
                              </table>
                              <div v-if="proceduralAdjustments && proceduralAdjustments.length > 0">
                                <p class="fs-mini text-muted mt-3">
                                    There are Procedural Adjustments for one of more patients. Click to view.
                                </p>

                                <b-button id="spa" variant="default" class="mb-xs mr-xs btn-xs">
                                      <span class="fs-mini fw-semi-bold" >Show Procedural Adjustments</span>
                                </b-button>
                                <b-popover target="spa" triggers="focus" placement="top">
                                  <template v-slot:title><b>Adjustments</b></template>              
                                  <table class="table">
                                    <thead>
                                      <tr>                                          
                                        <th>Date</th>                                          
                                        <th>Patient</th>
                                        <th>Total Adjustments</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(adj, index) in proceduralAdjustments" :key="index">                                          
                                        <td>{{new Date() | dateformat(dateFormatStr)}}</td>                                          
                                        <td>{{adj.Patient}}</td>
                                        <td><span class="text-success fw-semi-bold">{{adj.ProceduralAdjustments | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></td>                                                        
                                      </tr>
                                    </tbody>
                                  </table>
                                </b-popover>
                              </div> <!-- end of div surrounding Procedural Attachments if any -->

                            </div>
                          
                          </div>
                        
                      </b-col>
                      <b-col class="px-xl-3" md="12" lg="6" sm="12" xs="12" xl="6"> <!-- start of Production vs. Collection panel -->
                          <div>
                          <Widget class="mb-0 prod-vs-collection-widget"
                              title="<h5 class='fw-bold'>Production vs. Collection</h5>"
                              customHeader
                            >
                            <ProviderProductionChart :chartData="getProductionVsCollectionData" v-if="getProductionVsCollectionData" :key="`pcd-${new Date().getTime()}`"/>
                              <div class="table-responsive ml-2 mt-5">
                                  <table class="table tx-acceptance prod-vs-collect">
                                    <tbody>
                                      <tr>
                                        <td class="legend-col">
                                          <span class="glyphicon glyphicon-stop mr-2 mb-1" style="color:#a7beff;"></span>
                                        </td>
                                        <td class="title-col">
                                          <h6 class="fw-semi-bold h6 mt-1">Scheduled (Net)</h6>                
                                        </td>
                                        <td><h5 class="fw-semi-bold">{{this.scheduledTotal | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</h5>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td class="legend-col">
                                          <span class="glyphicon glyphicon-stop mr-2 mb-1" style="color:#ace5d1;" ></span>
                                        </td>
                                        <td class="title-col">
                                          <h6 class="fw-semi-bold h6 mt-1">Gross Production</h6>                
                                        </td>
                                        <td><h5 class="fw-semi-bold">{{this.grossProductionTotal | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</h5></td>
                                      </tr>
                                      <tr>
                                        <td><span class="glyphicon glyphicon-stop mr-2 mb-1" style="color:#FFA45B;"></span></td>
                                        <td>
                                          <h6 class="fw-semi-bold mt-1">Net Production (Completed)</h6>                    
                                        </td>
                                        <td><h5 class="fw-semi-bold">{{this.netAdjustedProductionTotal | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</h5></td>
                                      </tr> 
                                      <tr>
                                        <td>
                                          <span class="glyphicon glyphicon-stop mr-2 mb-1" style="color:#ffc247;"></span>
                                        </td>
                                        <td>
                                          <h6 class="fw-semi-bold mt-1">Collection</h6>
                                        </td>
                                        <td>
                                          <b-button id="collectionDetails" variant="warning" class="btn-xs">
                                            <span class="fw-semi-bold h5" >{{collectionTotal | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
                                          </b-button>
                                          <b-popover target="collectionDetails" triggers="focus" placement="bottom" custom-class="collections-popover" container="prod-vs-collect">
                                            <template v-slot:title><b>Total Collection: {{collectionTotal | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</b></template>              
                                            <h5 class="fw-semi-bold mt-2 mb-3">Insurance Payments: <span class="fw-semi-bold">{{totalInsurancePayments | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></h5>  
                                              <b-tabs >
                                                <b-tab title="Group by Patients" active>
                                                    <v-client-table v-if="collectionByPatientsInsurancePayments" :data="collectionByPatientsInsurancePayments" :columns="columns" :options="options">
                                                      <div slot="h__InsPayAmt"><span class="fw-semi-bold">Insurance Paid</span></div>
                                                      <div slot="h__InsPayEst"><span class="fw-semi-bold">Insurance Estimate</span></div>
                                                       <div slot="InsPayAmt" slot-scope="props">                                                
                                                        <span class="fw-semi-bold">{{props.row.InsPayAmt | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
                                                      </div> 
                                                      <div slot="InsPayEst" slot-scope="props">                                                
                                                        <span class="fw-semi-bold">{{props.row.InsPayEst | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
                                                      </div>
                                                    </v-client-table>
                                                </b-tab>
                                                <b-tab title="Group by Check">
                                                  <v-client-table v-if="collectionByInsuranceChecks" :data="collectionByInsuranceChecks" :columns="groupByCheckTableColumns" :options="options">
                                                      CheckAmt	PaymentType	Carrier	Patient	Provider
                                                      <div slot="h__CheckAmt"><span class="fw-semi-bold">Check Amount</span></div>
                                                      <div slot="h__PaymentType"><span class="fw-semi-bold">Payment Type</span></div>
                                                       <div slot="CheckAmt" slot-scope="props">                                                
                                                        <span class="fw-semi-bold">{{props.row.CheckAmt | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
                                                      </div> 
                                                  </v-client-table>
                                                </b-tab>
                                              </b-tabs>
                                            <h5 class="fw-semi-bold mt-2 mb-3">Patient Payments: <span class="fw-semi-bold">{{totalPatientPayments | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span></h5>  
                                                <v-client-table v-if="collectionPatientPayments" :data="collectionPatientPayments" :columns="patientPaymentTableColumns" :options="options">
                                                <div slot="h__PayAmt"><span class="fw-semi-bold">Pay Amount</span></div>
                                                <div slot="h__PaymentType"><span class="fw-semi-bold">Payment Type</span></div>
                                                <div slot="PayAmt" slot-scope="props">                                                
                                                  <span class="fw-semi-bold">{{props.row.PayAmt | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
                                                </div> 
                                                </v-client-table>                                              
                                          </b-popover>
                                        </td>
                                      </tr>  
                                    </tbody>
                                  </table>
                                </div>
                              
                            </Widget>
                          </div>
                      
                      </b-col>
                    </b-row>
                  </Widget>
                  </b-col>
                </b-row>



                <!-- BEGINNING OF TEST -->
                <b-row>
                  <b-col>
                  <Widget class="mb-3" kpiHelpTxPresented showTooltip customHeader> 
                    <b-row align-h="end">
                              <b-col>
                                <multiselect
                                  v-if="providersWithShowAll"
                                  v-model="selectedProvider"
                                  :options="providersWithShowAll"
                                  :multiple="false"
                                  :taggable="false"
                                  :show-labels="false"
                                  :custom-label="providerCustomLabel"
                                  track-by="ProvNum"
                                  placeholder="All Providers"/>
                              </b-col>
                            </b-row>
                            <hr/> 
                    <b-row>
                      <b-col class="px-xl-3" md="12" lg="6" sm="12" xs="12" xl="6"> <!-- start of Production (net) panel -->
                          <div>
                            <h5 class='fw-bold'>Treatment Presented vs. Accepted <span class='h6'>( scheduled )</span></h5>
                            
                            <ProviderProductionChart :chartData="getProviderProductionData" :chartStyle="chartStyle" v-if="getProviderProductionData" :key="`tpa-${new Date().getTime()}`"/>
                          <div class="table-responsive ml-2">
                              <table class="table tx-acceptance presented-vs-accepted">
                                <tbody>
                                  <tr>
                                    <td class="legend-col">
                                      <span class="glyphicon glyphicon-stop mr-2 mb-1" style="color:#a7beff;"></span>
                                    </td>
                                    <td class="title-col">
                                      <h6 class="fw-semi-bold h6 mt-1">Dollar value of today's Presented Treatment</h6>                
                                    </td>
                                    <td>
                                      <b-button id="todayPresented" variant="primary" class="btn-xs">
                                        <span class="fw-semi-bold" >{{presented | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
                                      </b-button>
                                      <b-popover target="todayPresented" triggers="focus" placement="right" custom-class="collections-popover">
                                        <template v-slot:title><b>Today's Presented Treatment: {{presented | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</b></template>              
                                            <v-client-table v-if="presentedVsAcceptedRawData" :data="presentedVsAcceptedRawData" :columns="presentedTxColumns" :options="options">
                                              <div slot="h__NetFee"><span class="fw-semi-bold">Net Fee</span></div>
                                              <div slot="h__ProcCode"><span class="fw-semi-bold">Procedure Code</span></div>
                                              <div slot="h__ToothSurface"><span class="fw-semi-bold">Tooth - Surface</span></div>
                                              <div slot="h__Descript"><span class="fw-semi-bold">Description</span></div>
                                              <div slot="NetFee" slot-scope="props">                                                
                                                <span class="fw-semi-bold">{{props.row.NetFee | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
                                              </div>
                                            </v-client-table>  
                                      </b-popover>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="legend-col"><span class="glyphicon glyphicon-stop mr-2 mb-1" style="color:#ace5d1;"></span></td>
                                    <td class="title-col">
                                      <h6 class="fw-semi-bold mt-1">Dollar value of Accepted Tx from What was Presented Today</h6>                    
                                    </td>
                                    <td>
                                      <b-button id="todayAccepted" variant="success" class="btn-xs">
                                        <span class="fw-semi-bold" >{{accepted | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
                                      </b-button>
                                      <b-popover target="todayAccepted" triggers="focus" placement="right" custom-class="collections-popover">
                                        <template v-slot:title><b>Today's Accepted Treatment: {{accepted | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</b></template>              
                                            <v-client-table v-if="acceptedRawData" :data="acceptedRawData" :columns="acceptedTxColumns" :options="options">
                                              <div slot="AptStatus" slot-scope="props">                                                
                                                <b-button v-if="props.row.AptStatus === 1" variant="success" class="mb-xs mr-xs btn-xs mt-xs">
                                                    <small><strong>Scheduled</strong></small>
                                                </b-button>
                                                <b-button v-if="props.row.AptStatus === 2" variant="success" class="mb-xs mr-xs btn-xs mt-xs">
                                                    <small><strong>Completed</strong></small>
                                                </b-button>
                                              </div>
                                              <div slot="h__NetFee"><span class="fw-semi-bold">Net Fee</span></div>
                                              <div slot="h__ProcCode"><span class="fw-semi-bold">Procedure Code</span></div>
                                              <div slot="h__ToothSurface"><span class="fw-semi-bold">Tooth - Surface</span></div>
                                              <div slot="h__Descript"><span class="fw-semi-bold">Description</span></div>
                                              <div slot="h__AptStatus"><span class="fw-semi-bold">Appointment Status</span></div>
                                              <div slot="NetFee" slot-scope="props">                                                
                                                <span class="fw-semi-bold">{{props.row.NetFee | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
                                              </div>
                                            </v-client-table>
                                      </b-popover>
                                    </td>
                                  </tr> 
                                  <tr>
                                    <td></td>
                                    <td class="title-col">
                                      <h5 class="fw-bold mt-1">Treatment Acceptance Rate</h5>
                                    </td>
                                    <td>
                                      <b-button id="paom"  class="btn-sm kpi-highlight">
                                        <span class="fw-bold" >{{treatmentAcceptanceRate || 0}}%</span>
                                      </b-button>
                                    </td>
                                  </tr>  
                                </tbody>
                              </table>
                            </div>
                            
                            
                            <!--
                            <b-row>
                              <b-col>
                                <h5 class="fw-semi-bold">Dollar Value of Other Accepted Treatment <span class="fs-mini">( previously Tx Planned )</span>: 
                                  <span>
                                    <b-button id="otherAccepted" variant="default" class="mb-xs  mr-xs btn-sm">
                                        <span class="fw-bold" >{{otherAcceptedTreatmentValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
                                    </b-button>
                                    <b-popover target="otherAccepted" triggers="focus" placement="right" custom-class="collections-popover">
                                      <template v-slot:title><b>Today's Other Accepted Treatment: {{otherAcceptedTreatmentValue | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</b></template>              
                                        <v-client-table v-if="otherAcceptedTreatmentRawData" :data="otherAcceptedTreatmentRawData" :columns="acceptedTxColumns" :options="options">
                                          <div slot="AptStatus" slot-scope="props">                                                
                                              <b-button v-if="props.row.AptStatus === 1" variant="success" class="mb-xs mr-xs btn-xs mt-xs">
                                                  <small><strong>Scheduled</strong></small>
                                              </b-button>
                                          </div>
                                          <div slot="h__NetFee"><span class="fw-semi-bold">Net Fee</span></div>
                                          <div slot="h__ProcCode"><span class="fw-semi-bold">Procedure Code</span></div>
                                          <div slot="h__ToothSurface"><span class="fw-semi-bold">Tooth - Surface</span></div>
                                          <div slot="h__Descript"><span class="fw-semi-bold">Description</span></div>
                                          <div slot="h__AptStatus"><span class="fw-semi-bold">Appointment Status</span></div>
                                          <div slot="NetFee" slot-scope="props">                                                
                                            <span class="fw-semi-bold">{{props.row.NetFee | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
                                          </div>
                                        </v-client-table>
                                    </b-popover>
                                  </span>
                                </h5> 
                                
                              </b-col>
                            </b-row>
                          -->
                          </div>
                        
                        
                      </b-col>
                      <b-col class="px-xl-3" md="12" lg="6" sm="12" xs="12" xl="6"> <!-- start of Completed Procedural Breakdown -->
                          <div>
                            <Widget class="mb-0 prod-vs-collection-widget"
                                title="<h5 class='fw-bold'>Completed Procedural Breakdown</h5>"
                                customHeader
                              >
                              <p>
                                By default, this list will display procedures completed by all providers. To filter by provider, select the provider
                                from drop-down below.
                              </p>

                                <v-client-table v-if="proceduralBreakdownByProcCodeData && selectedProvider.ProvNum === -1" 
                                  :data="proceduralBreakdownByProcCodeData" 
                                  :columns="proceduralBreakdownByProcCodeColumns" 
                                  :options="options" 
                                  @pagination-data="onPaginationData"
                                  @loading="this.setLoading(true)"
                                  @loaded="this.setLoading(false)"
                                  >
                                  <div slot="h__ProcCode"><span class="fw-semi-bold">Procedure Code</span></div>
                                  <div slot="h__Descript"><span class="fw-semi-bold">Procedural Description</span></div>
                                  <div slot="h__NetTotalFee"><span class="fw-semi-bold">Net Production</span></div>
                                  <div slot="h__Count"><span class="fw-semi-bold">Count</span></div>
                                  <div slot="NetTotalFee" slot-scope="props">                                                
                                    {{props.row.NetTotalFee | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
                                  </div>
                                  <div slot="Count" slot-scope="props">                                                
                                    <b-button id="countid" class="btn-sm kpi-highlight">
                                        <span class="fw-bold" >{{props.row.Count}}</span>
                                    </b-button>
                                    </div>
                                </v-client-table>

                                <v-client-table v-if="proceduralBreakdownByProcCodeAndProviderData && selectedProvider.ProvNum !== -1" 
                                  :data="proceduralBreakdownByProcCodeAndProviderData" 
                                  :columns="proceduralBreakdownByProcCodeAndProviderColumns" 
                                  :options="options"
                                  @pagination-data="onPaginationData"
                                  @loading="this.setLoading(true)"
                                  @loaded="this.setLoading(false)"
                                  >
                                  <div slot="h__ProcCode"><span class="fw-semi-bold">Procedure Code</span></div>
                                  <div slot="h__Descript"><span class="fw-semi-bold">Procedural Description</span></div>
                                  <div slot="h__NetTotalFee"><span class="fw-semi-bold">Net Production</span></div>
                                  <div slot="NetTotalFee" slot-scope="props">                                                
                                    {{props.row.NetTotalFee | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
                                  </div>  
                                  <div slot="Count" slot-scope="props">                                                
                                    <b-button id="countid" class="btn-sm kpi-highlight">
                                        <span class="fw-bold" >{{props.row.Count}}</span>
                                    </b-button>
                                  </div>                        
                                  
                                </v-client-table>
                                <b-row>
                                  <b-col cols="auto" class="ml-auto">Total Net Production: 
                                    <b-button id="paom"  class="btn-sm kpi-highlight">
                                        <span class="fw-bold" >{{proceduralBreakdownTotal | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
                                  </b-button>
                                  </b-col>
                                </b-row>
                                 
                                <!--
                                <b-row>
                                  <b-col md="10"></b-col>
                                  <b-col md="2" class="">Total Net Production(completed): ${{proceduralBreakdownTotal}}</b-col>
                                </b-row>
                                -->
                          </Widget>
                        </div>
                      
                      </b-col>
                    </b-row>
                  </Widget>
                  </b-col>
                </b-row>
                <!-- END OF TEST -->




                <b-row>
                  <b-col class="px-xl-3" md="12" xl="6" lg="6" sm="12" xs="12">
                    <div>
                        <Widget class="mb-0"
                          :title="totalPatientsTitle"
                          kpiHelpPatientsOnSchedule showTooltip customHeader
                          v-if="totalNewPatients"
                        >
                        <h5>New Patients: <span class="text-success">{{totalNewPatients.length}}</span></h5>

                        <!--
                        <v-client-table v-if="productionDataRaw" :data="productionDataRaw" :columns="patientsColumns" :options="options">
                        </v-client-table>
                        -->
                        
                        <div class="table-responsive" v-if="productionByProviderKeys && productionByProvider && hoursByProviderToShow">
                          <table class="table">
                            <thead>
                              <tr>                                
                                <th><span class="fw-semi-bold">Provider</span></th>
                                <th class="hidden-sm-down"><span class="fw-semi-bold">Patients on schedule</span></th>
                                <th class="hidden-sm-down"><span class="fw-semi-bold">Hours</span></th>
                                <th class="hidden-sm-down"><span class="fw-semi-bold">Scheduled Production / Hr</span></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(provider, index) in productionByProviderKeys" :key="index">                                
                                <td>{{provider}}</td>
                                <td>
                                  <p class="mb-0"><span class="h4">{{productionByProvider[provider].length}}</span> 
                                  <!-- ( <span class="fw-semi-bold text-success">2</span> NPs ) --> 
                                  </p>
                                </td>
                                <td><p>{{hoursByProviderToShow[provider] || 0}}</p></td>
                                <td class="width-150">
                                  <!-- <p>${{scheduledProductionPerHour(provider) || 0}} / hr</p>-->
                                  <b-button id="countid" class="btn-sm kpi-highlight">
                                        <span class="fw-bold" >{{scheduledProductionPerHour(provider) || 0 | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}} / hr</span>
                                  </b-button>
                                </td>
                              </tr>                              
                            </tbody>
                          </table>
                        </div>                        
                        </Widget>
                      </div>  
                  </b-col>
                </b-row>
            </b-tab>
            <b-tab disabled>
              <template v-slot:title>
                Tomorrow (coming soon)
                <span></span>
              </template>
            </b-tab>
          </b-tabs>
        </div>

        

    </div>
</template>

<script>
/* eslint-disable */

import Vue from "vue";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import Widget from "@/components/Widget/Widget";
import ErrorDisplay from "@/components/ErrorDisplay/ErrorDisplay";
import { mapState, mapActions, mapMutations } from 'vuex';
import moment from 'moment-timezone';
import mixin from '../../mixin.js';
import _ from 'lodash';

import ProviderProductionChart from '@/pages/KPI/ProviderProductionChart';

export default {
  name: 'KPI',
  components: { DatePicker, Multiselect, Widget, ErrorDisplay, ProviderProductionChart },
  mixins: [mixin],

  mounted() {
    //console.log('mounted');
  },

  created() {
    //console.log('created');
    //console.log(this.allSettings);
    if(this.allSettings)
      this.init();
  },

  data() {
    return {
      results: [],
      chartStyle: {
        width: '100%', height: '180px'
      },
      options: {
          skin: 'table',
          filterByColumn: false,
          perPage:5,
          pagination: { chunk: 8, dropdown: false },
          filterable: false,
          sortable: [],
          sortByColumn: false,
          texts: { filter: '', count: '', limit: '' },
      },
      columns: ['InsPayAmt', 'InsPayEst', 'Patient', 'Provider', 'Carrier'],
      patientPaymentTableColumns: ['PayAmt', 'Patient', 'PaymentType'],
      groupByCheckTableColumns: ['CheckAmt', 'PaymentType', 'Carrier', 'Patient', 'Provider'],
      presentedTxColumns: ['Patient', 'NetFee', 'ProcCode', 'ToothSurface', 'Descript', 'Provider'],
      acceptedTxColumns: ['Patient', 'NetFee', 'ProcCode', 'ToothSurface', 'Descript', 'Provider', 'AptStatus'],
      patientsColumns: ['Provider', 'PatientsOnSchedule', 'Hours', 'ScheduledProduction'],
      proceduralBreakdownByProcCodeColumns: ['ProcCode', 'Descript', 'Count', 'NetTotalFee'],
      proceduralBreakdownByProcCodeAndProviderColumns: ['ProcCode', 'Descript', 'Count', 'Provider', 'NetTotalFee'],
      selectedProvider: {
        FName: 'All',
        LName: 'Providers',
        ProvNum: -1
      }
    }
  },

  methods: {
    ...mapActions('teamio', ['runQuery']),
    ...mapMutations('teamio', ['emptyResults']),

    async init() {
      let query = {
        type: 'KPI',
        siteID: this.siteID,
        //_date: '2020-10-20',
        _date: this.$route.query.d ? this.$route.query.d : moment().format('YYYY-MM-DD'),
        odVersion: this.allSettings && this.allSettings.GENERAL_OPEN_DENTAL_DB_VERSION ? this.allSettings.GENERAL_OPEN_DENTAL_DB_VERSION.PropertyValue : null,
        setupByOp: this.allSettings && this.allSettings.KPI_SETUP_BY_OPERATORY ? this.allSettings.KPI_SETUP_BY_OPERATORY.PropertyValue : 'FALSE'
      };

      this.emptyResults();
      this.results = await this.runQuery(query);
    },

    providerCustomLabel({FName, MI, LName, Suffix, Abbr}) {
      if(MI && Abbr)
        return `${FName} ${MI} ${LName} ${Suffix} (${Abbr})`;
      else if(Abbr)
        return `${FName} ${LName} (${Abbr})`;
      else
        return `${FName} ${LName}`;
    },

    onPaginationData() {
      //console.log(`pagination called`);
    },
  },

  computed:{

    mainData() {
      if(this.results && this.results.data && this.results.data.length > 0)
        return this.results.data;
    },

    productionDataRaw() {
      if(this.mainData && this.mainData.length > 0) {
        return this.mainData[0];
      }
    },

    collectionByPatientsInsurancePayments() {
      if(this.mainData && this.mainData.length > 0) {
        return this.mainData[1];
      }
    },

    collectionByInsuranceChecks() {
      if(this.mainData && this.mainData.length > 0) {
        return this.mainData[2];
      }
    },

    collectionPatientPayments() {
      if(this.mainData && this.mainData.length > 0) {
        return this.mainData[3];
      }
    },

    presentedVsAcceptedRawData() {
      if(this.mainData && this.mainData.length > 0) {
        if(this.selectedProvider.ProvNum !== -1)
          return this.mainData[4].filter(o => o.ProvNum === this.selectedProvider.ProvNum);
        else
          return this.mainData[4];
      }
    },

    otherAcceptedTreatmentRawData() {
      if(this.mainData && this.mainData.length > 0) {
        if(this.selectedProvider.ProvNum !== -1)
          return this.mainData[5].filter(o => o.ProvNum === this.selectedProvider.ProvNum);
        else
          return this.mainData[5];
      }
    },

    proceduralBreakdownByProcCodeData() {
      if(this.mainData && this.mainData.length > 0) {
          this.mainData[6].total = 10;
          return this.mainData[6];
      }
    },

    proceduralBreakdownByProcCodeAndProviderData() {
      if(this.mainData && this.mainData.length > 0) {
        if(this.selectedProvider.ProvNum !== -1)
          return this.mainData[7].filter(o => o.ProvNum === this.selectedProvider.ProvNum);
        else
          return this.mainData[7];
      }
    },

    proceduralBreakdownTotal() {
      if(this.selectedProvider.ProvNum !== -1)
          return this.proceduralBreakdownByProcCodeAndProviderDataTotal;
      else
          return this.proceduralBreakdownByProcCodeDataTotal;
    },

    proceduralBreakdownByProcCodeDataTotal() {
      if(this.proceduralBreakdownByProcCodeData) {
        return _.sumBy(this.proceduralBreakdownByProcCodeData, 'NetTotalFee').toFixed(0);
      }
    },

    proceduralBreakdownByProcCodeAndProviderDataTotal() {
      if(this.proceduralBreakdownByProcCodeAndProviderData) {
        return _.sumBy(this.proceduralBreakdownByProcCodeAndProviderData, 'NetTotalFee').toFixed(0);
      }
    },

    hoursData() {
      if(this.mainData && this.mainData.length > 0) {
        return this.mainData[8];
      }
    },

    otherAcceptedTreatmentValue() {
      if(this.otherAcceptedTreatmentRawData) {
        return _.sumBy(this.otherAcceptedTreatmentRawData, function(o) { return o.NetFee}).toFixed(0);
      }
    },

    presented() {
      if(this.presentedVsAcceptedRawData) {
        return _.sumBy(this.presentedVsAcceptedRawData, function(o) { return o.NetFee}).toFixed(0);
      }
    },

    acceptedRawData() {
      if(this.presentedVsAcceptedRawData) {
        return this.presentedVsAcceptedRawData.filter(o => o.AptStatus === 1 || o.AptStatus === 2);
      }
    },

    accepted() {
      if(this.presentedVsAcceptedRawData) {
        return _.sumBy(this.presentedVsAcceptedRawData, function(o) { return o.AptStatus === 1 || o.AptStatus === 2 ? o.NetFee : 0}).toFixed(0);
      }
    },

    treatmentAcceptanceRate() {
      if(this.accepted && this.presented) {
        return Math.round((this.accepted / this.presented) * 100);
      }
    },

    providersDataRaw() {
      if (this.productionDataRaw) {
        return _.groupBy(this.productionDataRaw, (n) => n.Provider);
      }
    },

    productionDataByProvider() {

      if(this.providersDataRaw) {
        return _.map(this.providersDataRaw, function (n, k) {
          let providersWithCompleted = _.filter(n, function (n1) {
            return n1.AptStatus === 2;
          });
          //console.log(`providersWithCompleted: ${providersWithCompleted}`);

          let providersWithScheduled = _.filter(n, function (n1) {
            return n1.AptStatus === 1;
          });

          //console.log(`providersWithScheduled: ${providersWithScheduled}`);

          let productionTotal = _.sum(
            _.map(providersWithCompleted, function (n2) {
              return n2.ProceduralAdjustments + n2.AdjustedValue;
            })
          );

          let scheduledTotal = _.sum(
           /*
           for the Scheduled(net) column: we should show the aptValue total REGARDLESS of appointment status (whether completed or not) - 
           if it's on the schedule, we should show it!
           */
           _.map(n, function (n2) {
              //return n2.ProceduralAdjustments + n2.AdjustedValue;
              return n2.AdjustedValue - n2.ProceduralDiscounts ;
            })
          );

          let IsSecondary = _.map(n, function(n2) {
            return n2.IsSecondary;
          })[0];

          //console.log(`production total: ${productionTotal}`);
          //console.log(`Scheduled total: ${scheduledTotal}`);
          //console.log(k);
          return {
            provider: k,
            productionTotal,
            scheduledTotal,
            IsSecondary
          };
        });
      }
    },

    proceduralAdjustments() {
      if (this.productionDataRaw) {
        return this.productionDataRaw.filter(a => a.ProceduralAdjustments !== null);
      }
    },

    scheduledTotal() {
      if(this.productionDataRaw)
        //return _.sumBy(this.productionDataRaw, function(o) { return o.AptStatus === 1 ? o.AdjustedValue + o.ProceduralAdjustments : 0 });
        return _.sumBy(this.productionDataRaw, function(o) { return o.AdjustedValue - o.ProceduralAdjustments });
    },

    grossProductionTotal() {
      if(this.productionDataRaw)
        return _.sumBy(this.productionDataRaw, function(o) { return o.AptStatus === 2 ? o.GrossAppointmentValue : 0 });
    },

    netAdjustedProductionTotal() {
      if(this.productionDataRaw)
        return _.sumBy(this.productionDataRaw, function(o) { return o.AptStatus === 2 ? o.AdjustedValue + o.ProceduralAdjustments : 0 });
    },

    netAdjustedProductionTotalPercentageCompleted() {
      if(this.netAdjustedProductionTotal && this.allSettings 
          && this.allSettings.PRACTICE_INSIGHTS_DAILY_NET_PRODUCTION_GOAL 
          && this.allSettings.PRACTICE_INSIGHTS_DAILY_NET_PRODUCTION_GOAL.PropertyValue !== '' 
          && this.allSettings.PRACTICE_INSIGHTS_DAILY_NET_PRODUCTION_GOAL !== 0) {
        return ((this.netAdjustedProductionTotal / this.allSettings.PRACTICE_INSIGHTS_DAILY_NET_PRODUCTION_GOAL.PropertyValue)*100).toFixed(0);
      }
    },

    totalInsurancePayments() {
      if(this.collectionByPatientsInsurancePayments) {
        return _.sumBy(this.collectionByPatientsInsurancePayments, 'InsPayAmt');
      }
    },

    totalPatientPayments() {
      if(this.collectionPatientPayments) {
        return _.sumBy(this.collectionPatientPayments, 'PayAmt');
      }
    },

    collectionTotal() {
      if(this.totalInsurancePayments || this.totalPatientPayments)
        return Math.round(this.totalInsurancePayments + this.totalPatientPayments);
    },

    getProviderProductionData() {
      if(this.presented >= 0 && this.accepted >= 0) {
        return { 
          options: {
            series: {
              bars: {
                barWidth:0.5,
              }
            },
            xaxis: {
              min: 0,
              max: 5,
              ticks: [
                [2, "Presented"], [3, "Accepted"]
              ]          
            }
          },
          data: [
            {        
              data: [[2, this.presented]],       
            }, 
            {        
              data:  [[3, this.accepted]],
            }    
          ]
          }
      }
    },  

    getProductionVsCollectionData() {
      //console.log(`scheduledTotal: ${this.scheduledTotal}, grossProductionTotal: ${this.grossProductionTotal}, netAdjustedProductionTotal: ${this.netAdjustedProductionTotal}, collectionTotal: ${this.collectionTotal}`);
        if(this.scheduledTotal >= 0 || this.grossProductionTotal >= 0 || this.netAdjustedProductionTotal >= 0 || this.collectionTotal >= 0) {
        return { 
          options: {
            xaxis: {
              ticks: [
                [5, "Scheduled"], [10, "Gross Production"], [15, "Net Production"], [20, "Collection"]
              ]          
            }
          },
          data: [
            {            
              label: "Total Scheduled",
              data:  [[5, this.scheduledTotal]]
            },
            {
              label: "Total Production",
              data: [[10, this.grossProductionTotal]]
            }, 
            {            
              label: "Total Net Adjusted Production",
              data:  [[15, this.netAdjustedProductionTotal]]
            },
            {            
              label: "Total Collection",
              data:  [[20, this.collectionTotal]]
            } 
          ]
        } 
      }
  },

  totalPatientsTitle() {
    if(this.totalPatientsOnSchedule)
      return "<h5 class='fw-bold'>Total Patients on Schedule: <span class='h2 fw-semi-bold text-succes'>" + this.totalPatientsOnSchedule.length + "</span></h5>";
  },

  totalPatientsOnSchedule() {
    if(this.productionDataRaw) {
       return [...new Set(this.productionDataRaw.map(item => item.Patient))];
    }
  },

  totalNewPatients() {
    if(this.productionDataRaw) {
      if(this.selectedProvider.ProvNum !== -1)
        return this.productionDataRaw.filter(o => o.ProvNum === this.selectedProvider.ProvNum && o.IsNewPatient === 1);
      else
        return this.productionDataRaw.filter(o => o.IsNewPatient === 1);
    }
  },

  productionByProvider() {
    if(this.productionDataRaw) {
      return _.groupBy(this.productionDataRaw, 'Provider');
    }
  },

  productionByProviderKeys() {
    if(this.productionByProvider) {
      return _.keys(this.productionByProvider);
    }
  },

  hoursByProvider() {
    if(this.hoursData) {
      return _.groupBy(this.hoursData, 'Provider');
    }
  },

  hoursByProviderToShow() {
    let ret = {};
    if(this.hoursByProvider) {
      for (var provider in this.hoursByProvider) {
        let providerData = this.hoursByProvider[provider];
        if(providerData.length > 0) {
          /* we are filtering only when IsSecondary is null or 1 because some offices have the provider as also the HYGIENIST set for the appointment. */
          providerData = providerData.filter(p => p.IsSecondary === 0 || p.IsSecondary === 1 || p.IsSecondary === null);
          let earliestStartTime = parseInt(_.minBy(providerData, function(o) {
            return parseInt(o.StartTime);
          }).StartTime);
          let latestStopTime = parseInt(_.maxBy(providerData, function(o) {
            return parseInt(o.StopTime);
          }).StopTime);
          //console.log(`For ${provider}, Earliest time: ${earliestStartTime}`);
          //console.log(`For ${provider}  Latest time: ${latestStopTime}`);
          let totalHoursWorkedBeforeAdjustment = latestStopTime - earliestStartTime;
          //console.log(`For ${provider}  total hours worked before adjustments: ${totalHoursWorkedBeforeAdjustment}`);
          // now need to subtract any lunch hours, etc..

          let opDataByProvider = _.groupBy(providerData, 'OperatoryNum');
          //console.dir(opDataByProvider);
          let firstOpData = Object.values(opDataByProvider)[0];
          //console.dir(firstOpData);
          
          let breakDurationInHours=0;
          let start, end;
          let finalHours=0;
          
          for (var i=0; i<firstOpData.length-1; i++) {
            start = moment(`${moment().format('YYYY-MM-DD')} ${firstOpData[i+1].StartTime}`);
            end = moment(`${moment().format('YYYY-MM-DD')} ${firstOpData[i].StopTime}`);
            breakDurationInHours += moment.duration(start.diff(end)).asHours();
          }
          //console.log(`break duration in hours for ${provider}: ${breakDurationInHours}`);
          finalHours = totalHoursWorkedBeforeAdjustment - breakDurationInHours;
          //console.log(`final duration in hours for ${provider}: ${finalHours}`);
          ret[provider] = finalHours; 
        }       
      }
    }
    return ret;
  },

  sumOfHoursByProviders() {
    if(this.hoursByProvider) {
      return _.mapValues(this.hoursByProvider, function(o) {
        //console.log(o);
        //let s = _.sumBy(o, 'Hours');
        let s = o[0].Hours;
        //console.log(s);
        return s;
      });
    }
  },

  totalScheduledForProvider: function() {
    let vm = this;
    return function(provider) {
      return this.productionDataByProvider.filter(o => o.provider === provider)[0].scheduledTotal;
    }
  },

  scheduledProductionPerHour: function() {
    if(this.totalScheduledForProvider && this.sumOfHoursByProviders) {
      let vm = this;
      return function(provider) {
        return Math.round(this.totalScheduledForProvider(provider) / this.sumOfHoursByProviders[provider]);
      }
    }
  },

  providersWithShowAll() {
    if(this.providers) {
      let temp = [...this.providers];
        let o = {
            FName: 'All',
            LName: 'Providers',
            ProvNum: -1,
        }
        temp.unshift(o);
        return temp;
    }
  },  

},

watch: {
  allSettings(newValue, oldValue) {        
    //console.log(`watch changed. Old value: ${JSON.stringify(oldValue)}, \n New value: ${JSON.stringify(newValue)}`);
    if(!oldValue) {
      this.init();
    }        
  }
}

}

</script>